export const validateRefregaSchema = json => {
    return true;
};
